import { useState } from "react";
import { Form } from "react-bootstrap";
import SntSearchIcon from "@icons/SntSearchIcon";
import { useDebouncedEffect } from "@hooks/useDebouncedEffect";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";

interface SearchInputProps {
  onChange?: (query: string | null) => void;
  setShowSearchPanel?: (show: boolean) => void;
  id?: string;
  autoFocus?: boolean;
}

function SearchInput({
  onChange,
  setShowSearchPanel,
  id,
  autoFocus,
}: SearchInputProps) {
  const [query, setQuery] = useState<string | null>(null);

  useDebouncedEffect(() => onChange && onChange(query), 200, [query]);

  return (
    <>
      <Form.Control
        placeholder={translate(LanguageKey.input_search_key)}
        autoComplete="off"
        autoFocus={autoFocus}
        onFocus={() => setShowSearchPanel && setShowSearchPanel(true)}
        onChange={(e) => {
          setQuery(e.target.value);
        }}
        id={id}
        style={{ position: "relative", paddingLeft: 35, height: 36 }}
      />

      <SntSearchIcon
        style={{ position: "absolute", top: 9, left: 10, color: "#999" }}
      />
    </>
  );
}

export default SearchInput;
